import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import {
	cardCreateFilteredV2,
	CARD_CREATE_SUCCESS,
	type CardCreateSuccessAction,
} from '../../state/actions/cards/create/index.tsx';
import { makeOrderedVisibleCardIdsForCardList } from '../../state/selectors/cards/index.tsx';
import type { ActionsObservable, MiddlewareAPI, State } from '../../state/types.tsx';

const getActiveCustomFilterIds = (state: State): string[] => state.ui.filters.CUSTOM_FILTER || [];
const isCustomFiltersActive = (state: State) => getActiveCustomFilterIds(state).length > 0;

export const cardPostCreateEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$.ofType(CARD_CREATE_SUCCESS).mergeMap((action: CardCreateSuccessAction) => {
		const state = store.getState();
		const visibleCardIds = makeOrderedVisibleCardIdsForCardList(state)(action.payload.listId);

		if (!visibleCardIds.includes(action.payload.card.id)) {
			// don't show this flag here if custom filters are active,
			// we'll show it after the refiltering succeeds
			if (!isCustomFiltersActive(state)) {
				return Observable.of(cardCreateFilteredV2([action.payload.card.id]));
			}
		}
		return Observable.empty<never>();
	});
